import Icon from "components/icon";
import { Link } from "react-router-dom";
import React from "react";
import { UP_RIGHT } from "icons";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

const PendingIntegrationBanner = () => {
  const user = useSelector(selectUser);
  if (user.discord_user_id || user.github_username) return null;

  return (
    <aside
      role="banner"
      aria-label="Integration announcement"
      // className="fixed top-16 left-0 right-0 mx-auto px-6"
      className="pt-6 px-6"
    >
      <div className="flex items-center bg-yellow-50 pl-4 pr-6 py-3 md:py-4 relative rounded-xl  mx-auto">
        <Link
          to="/profile/integrations"
          className="flex items-center justify-start gap-2 w-full cursor-pointer"
          aria-label="Learn more about shadcn/ui kit Pro blocks"
        >
          <span className="text-sm text-yellow-800">
            <span className="font-semibold">Note</span> · You haven’t connected
            one of the integration.
          </span>
        </Link>
        <Link
          className="absolute right-2 w-8 h-8 flex items-center justify-center rounded-md hover:bg-white/10"
          aria-label="Close announcement"
          to="/profile/integrations"
        >
          <Icon className="size-4" aria-hidden="true" icon={UP_RIGHT} />
          <span className="sr-only">GoTo Integrations</span>
        </Link>
      </div>
    </aside>
  );
};

export default PendingIntegrationBanner;
